export default {
    API_BASE_URL: "https://api.dh-thailand.com/graphql",
};
